import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { OrganisationSettingsService } from 'libs/shared/util-common/src/lib/organisation-settings.service';
import { ucumToTimeUnit, ucumUnitToTranslateKey } from 'shared/util-common';

import { IconDirective } from '../icon/icon.directive';

@Component({
  selector: 'tt-revision-date-tooltip',
  standalone: true,
  imports: [TranslocoPipe, IconDirective, MatIconModule],
  templateUrl: './revision-date-tooltip.component.html',
  styleUrl: './revision-date-tooltip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RevisionDateTooltipComponent {
  protected soonToExpireTime: number;
  protected soonToExpireUnitKey: string;

  constructor() {
    const soonToExpirePeriod = ucumToTimeUnit(
      inject(OrganisationSettingsService).settings().revisionDateSettings?.soonToExpirePeriod ?? '3mo',
    );

    this.soonToExpireTime = soonToExpirePeriod[0];
    this.soonToExpireUnitKey = ucumUnitToTranslateKey(soonToExpirePeriod[1]);
  }
}
